import React from 'react'
import { Link } from 'react-router-dom'

const SocialLinks = ({ settings, style = "default" }) => {
    // Define the styling classes based on the style prop
    const getClasses = (isDisabled) => {
        let baseClasses = "";
        
        switch (style) {
            case "footer-one":
                baseClasses = "w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle"
                break;
            case "footer-two":
                baseClasses = "text-xl w-44 h-44 flex-center bg-main-two-50 text-main-two-600 rounded-8"
                break;
            case "footer-three":
                baseClasses = "w-44 h-44 flex-center bg-main-two-50 text-main-two-600 text-xl rounded-8"
                break;
            case "vendor":
                baseClasses = "w-36 h-36 flex-center bg-white text-main-600 text-lg rounded-circle"
                break;
            case "product":
                baseClasses = "text-xl w-44 h-44 flex-center bg-main-100 text-main-600 rounded-circle"
                break;
            default:
                baseClasses = "w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle"
                break;
        }
        
        // Add hover effects only if not disabled
        if (!isDisabled) {
            baseClasses += " hover-bg-main-600 hover-text-white";
        } else {
            baseClasses += " opacity-50 cursor-not-allowed";
        }
        
        return baseClasses;
    }

    // Check if any social media links exist
    const hasSocialLinks = true;
    
    // If no social links, render disabled placeholders with tooltip
    if (!hasSocialLinks) {
        return (
            <ul className="gap-16 flex-align">
                <li>
                    <span
                        className={getClasses(true)}
                        title="Facebook profile not available"
                    >
                        <i className="ph-fill ph-facebook-logo" />
                    </span>
                </li>
                <li>
                    <span
                        className={getClasses(true)}
                        title="Twitter profile not available"
                    >
                        <i className="ph-fill ph-twitter-logo" />
                    </span>
                </li>
                <li>
                    <span
                        className={getClasses(true)}
                        title="Instagram profile not available"
                    >
                        <i className="ph-fill ph-instagram-logo" />
                    </span>
                </li>
            </ul>
        )
    }
    
    // Regular rendering with active links
    return (
        <ul className="gap-16 flex-align">
            {(
                <li>
                    <Link
                        to={'https://www.facebook.com/maceraalimentos'}
                        className={getClasses(false)}
                    >
                        <i className="ph-fill ph-facebook-logo" />
                    </Link>
                </li>
            )}
            {/* {settings?.twitter_url && (
                <li>
                    <Link
                        to={settings.twitter_url}
                        className={getClasses(false)}
                    >
                        <i className="ph-fill ph-twitter-logo" />
                    </Link>
                </li>
            )} */}
            {(
                <li>
                    <Link
                        to={'https://www.instagram.com/maceralimentos'}
                        className={getClasses(false)}
                    >
                        <i className="ph-fill ph-instagram-logo" />
                    </Link>
                </li>
            )}
        </ul>
    )
}

export default SocialLinks 